import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, map, Observable } from 'rxjs';

export interface PhonePrefix {
    code: string;
    prefix: string;
    url: string;
    nameTranslated?: string;
}

@Injectable({
    providedIn: 'root',
})

export class PhonePrefixService {

    constructor(private translateService: TranslateService) {
    }

    private readonly basePhonePrefixes = [
        { code: 'ES', prefix: '+34', url: '/assets/images/flags/spain.webp' },
        { code: 'FR', prefix: '+33', url: '/assets/images/flags/france.webp' },
        { code: 'GB', prefix: '+44', url: '/assets/images/flags/united_kingdom.webp' },
        { code: 'IT', prefix: '+39', url: '/assets/images/flags/italy.webp' },
        { code: 'DE', prefix: '+49', url: '/assets/images/flags/germany.webp' },
        { code: 'PT', prefix: '+351', url: '/assets/images/flags/portugal.webp' },
        { code: 'NL', prefix: '+31', url: '/assets/images/flags/netherlands.webp' },
        { code: 'AD', prefix: '+376', url: '/assets/images/flags/andorra.webp' },
    ];

    async getPhonePrefixesSorted(): Promise<PhonePrefix[]> {
        const keys = this.basePhonePrefixes.map(p => `FLAG_COUNTRY.${p.code}`);
        const translations = await firstValueFrom(this.translateService.get(keys));

        const translated = this.basePhonePrefixes.map(p => ({
            ...p,
            nameTranslated: translations[`FLAG_COUNTRY.${p.code}`],
        }));

        return translated.sort((a, b) =>
            (a.nameTranslated ?? a.code).localeCompare(b.nameTranslated ?? b.code)
        );
    }

    async getPhonePrefixes(): Promise<PhonePrefix[]> {
        const keys = this.basePhonePrefixes.map(p => `FLAG_COUNTRY.${p.code}`);
        const translations = await firstValueFrom(this.translateService.get(keys));

        return this.basePhonePrefixes.map(p => ({
            ...p,
            nameTranslated: translations[`FLAG_COUNTRY.${p.code}`],
        }));
    }

}
